import React, { useEffect } from 'react';
import './LoginPage.css';
import { useKeycloak } from '@react-keycloak/web';
import { useNavigate } from 'react-router-dom';
import Loading from './Loading';

const LoginPage = () => {
  const { keycloak, initialized } = useKeycloak();
  const navigate = useNavigate();

  useEffect(() => {
    if (initialized) {
      console.log("Verificando autenticação...");
      if (keycloak.authenticated) {
        console.log("Usuário autenticado, redirecionando para o dashboard...");
        navigate('/dashboard');
      }
    }
  }, [keycloak, initialized, navigate]);

  const handleLogin = () => {
    console.log("Iniciando o login...");
    if (initialized) {
      keycloak.login();
    }
  };

  return (
    <div className="container">
      <div className="login-box">
        <img src="https://gruposupritec.com.br/uploads/loja_logo/24/c507ad7e71a46856a60fdc95e41669fe.png" alt="Logo" className="logo" />
        <h1 className="title">Bem-vindo ao Dashboard</h1>
        <p className="subtitle">Faça login para continuar</p>
        {initialized ? (
          <button className="login-button" onClick={handleLogin}>Entrar</button>
        ) : (
          <Loading />
        )}
      </div>
    </div>
  );
};

export default LoginPage;
